"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DayIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.98 1c-.43 0-.78.448-.78 1v2c0 .552.35 1 .78 1 .43 0 .78-.448.78-1V2c0-.552-.35-1-.78-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4.16v9.661a1 1 0 001 1h11.9a1 1 0 001-1v-8.94a1.98 1.98 0 01-3.825-.72V2.41h-1.09v1.75a1.98 1.98 0 11-3.96 0V2.41H4.96v1.75a1.98 1.98 0 11-3.96 0zm6.092 7.915L5.277 10.26a.792.792 0 011.12-1.12l.695.696L9.57 7.358a.792.792 0 011.12 1.12l-3.598 3.597z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.23 2c0-.552.35-1 .78-1 .43 0 .78.448.78 1v2c0 .552-.35 1-.78 1-.43 0-.78-.448-.78-1V2zm5.815-1c-.43 0-.78.448-.78 1v2c0 .552.35 1 .78 1 .43 0 .78-.448.78-1V2c0-.552-.35-1-.78-1z"
  })))
});
DayIcon.displayName = 'DayIcon';
var _default = exports.default = DayIcon;